import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = {
  key: 1,
  ref: "bvForm",
  class: "p-fluid p-formgrid p-grid p-mt-4 p-mx-2 kn-flex-0"
}
const _hoisted_2 = { class: "p-field p-col-12 p-md-6" }
const _hoisted_3 = { class: "p-float-label " }
const _hoisted_4 = {
  for: "source",
  class: "kn-material-input-label"
}
const _hoisted_5 = { class: "p-field p-col-12 p-md-6" }
const _hoisted_6 = { class: "p-float-label " }
const _hoisted_7 = {
  for: "target",
  class: "kn-material-input-label"
}
const _hoisted_8 = {
  key: 3,
  id: "summary-container",
  class: "p-m-3 p-d-flex p-flex-column kn-flex-05"
}
const _hoisted_9 = { class: "kn-relative kn-flex" }
const _hoisted_10 = { class: "associator-block-hover p-d-flex p-flex-row p-ai-center kn-width-full" }
const _hoisted_11 = { class: "kn-truncated kn-flex-05 p-ml-2" }
const _hoisted_12 = {
  key: 0,
  class: "fas fa-link kn-flex-05"
}
const _hoisted_13 = { class: "kn-truncated" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Toolbar = _resolveComponent("Toolbar")
  const _component_StepOne = _resolveComponent("StepOne")
  const _component_Dropdown = _resolveComponent("Dropdown")
  const _component_TableAssociator = _resolveComponent("TableAssociator")
  const _component_Button = _resolveComponent("Button")
  const _component_Listbox = _resolveComponent("Listbox")
  const _component_Dialog = _resolveComponent("Dialog")

  return (_openBlock(), _createBlock(_component_Dialog, {
    class: "bsdialog",
    style: _ctx.bsDescriptor.style.bsDialog,
    visible: _ctx.showBusinessViewDialog,
    modal: true,
    closable: false
  }, {
    header: _withCtx(() => [
      _createVNode(_component_Toolbar, { class: "kn-toolbar kn-toolbar--primary kn-width-full" }, {
        start: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('metaweb.businessModel.newView')), 1)
        ]),
        _: 1
      })
    ]),
    footer: _withCtx(() => [
      _createVNode(_component_Button, {
        class: "p-button-text kn-button",
        label: _ctx.$t('common.cancel'),
        onClick: _ctx.closeDialog
      }, null, 8, ["label", "onClick"]),
      (_ctx.wizardStep == 2 && !_ctx.editMode)
        ? (_openBlock(), _createBlock(_component_Button, {
            key: 0,
            class: "kn-button kn-button--secondary",
            label: _ctx.$t('common.back'),
            disabled: _ctx.buttonDisabled || _ctx.summary.length > 0,
            onClick: _ctx.previousStep
          }, null, 8, ["label", "disabled", "onClick"]))
        : _createCommentVNode("", true),
      (_ctx.wizardStep == 1)
        ? (_openBlock(), _createBlock(_component_Button, {
            key: 1,
            class: "kn-button kn-button--primary",
            label: _ctx.$t('common.next'),
            disabled: _ctx.buttonDisabled,
            onClick: _ctx.nextStep
          }, null, 8, ["label", "disabled", "onClick"]))
        : _createCommentVNode("", true),
      (_ctx.wizardStep == 2)
        ? (_openBlock(), _createBlock(_component_Button, {
            key: 2,
            class: "kn-button kn-button--primary",
            label: _ctx.$t('common.save'),
            disabled: _ctx.buttonDisabled,
            onClick: _ctx.saveBusinessView
          }, null, 8, ["label", "disabled", "onClick"]))
        : _createCommentVNode("", true)
    ]),
    default: _withCtx(() => [
      (_ctx.wizardStep === 1)
        ? (_openBlock(), _createBlock(_component_StepOne, {
            key: 0,
            physicalModels: _ctx.physicalModels,
            showBusinessViewDialog: _ctx.showBusinessViewDialog,
            bnssViewObject: _ctx.tmpBnssView
          }, null, 8, ["physicalModels", "showBusinessViewDialog", "bnssViewObject"]))
        : _createCommentVNode("", true),
      (_ctx.wizardStep === 2)
        ? (_openBlock(), _createBlock("form", _hoisted_1, [
            _createVNode("div", _hoisted_2, [
              _createVNode("span", _hoisted_3, [
                _createVNode(_component_Dropdown, {
                  id: "source",
                  class: "kn-material-input",
                  modelValue: _ctx.sourceTable,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.sourceTable = $event)),
                  options: _ctx.tmpBnssView.physicalModels,
                  optionLabel: "name"
                }, null, 8, ["modelValue", "options"]),
                _createVNode("label", _hoisted_4, _toDisplayString(_ctx.$t('metaweb.businessModel.sourceTable')), 1)
              ])
            ]),
            _createVNode("div", _hoisted_5, [
              _createVNode("span", _hoisted_6, [
                _createVNode(_component_Dropdown, {
                  id: "target",
                  class: "kn-material-input",
                  modelValue: _ctx.targetTable,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.targetTable = $event)),
                  options: _ctx.tmpBnssView.physicalModels,
                  optionLabel: "name"
                }, null, 8, ["modelValue", "options"]),
                _createVNode("label", _hoisted_7, _toDisplayString(_ctx.$t('metaweb.businessModel.targetTable')), 1)
              ])
            ])
          ], 512))
        : _createCommentVNode("", true),
      (_ctx.wizardStep === 2)
        ? (_openBlock(), _createBlock(_component_TableAssociator, {
            key: 2,
            class: "kn-flex",
            sourceArray: _ctx.sourceTable.columns,
            targetArray: _ctx.targetTable.columns,
            useMultipleTablesFromSameSource: true,
            onDrop: _ctx.updateSummary,
            onRelationshipDeleted: _ctx.updateSummary
          }, null, 8, ["sourceArray", "targetArray", "onDrop", "onRelationshipDeleted"]))
        : _createCommentVNode("", true),
      (_ctx.wizardStep === 2)
        ? (_openBlock(), _createBlock("div", _hoisted_8, [
            _createVNode(_component_Toolbar, { class: "kn-toolbar kn-toolbar--primary" }, {
              start: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('metaweb.businessModel.summary')), 1)
              ]),
              end: _withCtx(() => [
                (!_ctx.expandSummary)
                  ? (_openBlock(), _createBlock(_component_Button, {
                      key: 0,
                      icon: "fas fa-chevron-right",
                      class: "p-button-text p-button-rounded p-button-plain",
                      style: {"color":"white"},
                      onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.expandSummary = true))
                    }))
                  : (_openBlock(), _createBlock(_component_Button, {
                      key: 1,
                      icon: "fas fa-chevron-down",
                      class: "p-button-text p-button-rounded p-button-plain",
                      style: {"color":"white"},
                      onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.expandSummary = false))
                    }))
              ]),
              _: 1
            }),
            _createVNode("div", _hoisted_9, [
              _withDirectives(_createVNode(_component_Listbox, {
                class: "kn-list data-condition-list kn-absolute kn-height-full kn-width-full kn-overflow",
                options: _ctx.summary
              }, {
                empty: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('metaweb.businessModel.summaryHint')), 1)
                ]),
                option: _withCtx((slotProps) => [
                  _createVNode("div", _hoisted_10, [
                    _createVNode("span", _hoisted_11, _toDisplayString(slotProps.option.name), 1),
                    (slotProps.option['links'] && slotProps.option['links'].length > 0)
                      ? (_openBlock(), _createBlock("i", _hoisted_12))
                      : _createCommentVNode("", true),
                    (slotProps.option['links'] && slotProps.option['links'].length > 0)
                      ? (_openBlock(), _createBlock("div", {
                          key: 1,
                          class: ["p-d-flex p-flex-column kn-flex", { 'p-mb-1': slotProps.option['links'].length > 1 }]
                        }, [
                          (_openBlock(true), _createBlock(_Fragment, null, _renderList(slotProps.option['links'], (link, index) => {
                            return (_openBlock(), _createBlock("span", {
                              class: "p-d-flex p-flex-row p-ai-center",
                              key: index
                            }, [
                              _createVNode("span", _hoisted_13, _toDisplayString(link.name), 1),
                              (slotProps.option['links'].length > 1)
                                ? (_openBlock(), _createBlock(_component_Button, {
                                    key: 0,
                                    icon: "fas fa-times",
                                    class: "associator-enable-hover p-button-text p-button-rounded p-button-plain",
                                    onClick: _withModifiers(($event: any) => (_ctx.deleteRelationship(slotProps.option, link)), ["stop"])
                                  }, null, 8, ["onClick"]))
                                : _createCommentVNode("", true)
                            ]))
                          }), 128))
                        ], 2))
                      : _createCommentVNode("", true),
                    (slotProps.option['links'] && slotProps.option['links'].length > 0)
                      ? (_openBlock(), _createBlock(_component_Button, {
                          key: 2,
                          icon: "far fa-trash-alt kn-flex-0",
                          class: "associator-enable-hover p-button-text p-button-rounded p-button-plain",
                          onClick: _withModifiers(($event: any) => (_ctx.deleteRelationship(slotProps.option)), ["stop"])
                        }, null, 8, ["onClick"]))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _: 1
              }, 8, ["options"]), [
                [_vShow, _ctx.expandSummary]
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["style", "visible"]))
}